import { render, staticRenderFns } from "./PFDSModal.vue?vue&type=template&id=1034b7ba&scoped=true"
import script from "./PFDSModal.vue?vue&type=script&lang=js"
export * from "./PFDSModal.vue?vue&type=script&lang=js"
import style0 from "./PFDSModal.vue?vue&type=style&index=0&id=1034b7ba&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1034b7ba",
  null
  
)

export default component.exports